import { render } from "./ExpertStatisticsQueueTableDetail.vue?vue&type=template&id=32da88fc"
import script from "./ExpertStatisticsQueueTableDetail.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsQueueTableDetail.vue?vue&type=script&lang=js"

import "./ExpertStatisticsQueueTableDetail.vue?vue&type=style&index=0&id=32da88fc&lang=css"
script.render = render

export default script